<container *ngIf="_contest">
    <div class="flex items-center gap-x-2 bg p-4">
        <app-contest-banner [contest]="_contest"></app-contest-banner>
    </div>
</container>
